const topicTags = [
  { label: '古装权谋', count: '126.8万' },
  { label: '悬疑推理', count: '98.3万' },
  { label: '科幻巨制', count: '87.6万' },
  { label: '甜宠爱情', count: '156.2万' },
  { label: '热血动漫', count: '73.4万' },
  { label: '喜剧搞笑', count: '112.9万' },
  { label: '恐怖惊悚', count: '45.7万' },
  { label: '战争历史', count: '38.1万' },
  { label: '都市情感', count: '94.5万' },
  { label: '奇幻冒险', count: '67.2万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <span className="text-xs text-accent-400 whitespace-nowrap">热门分类</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-50 mb-3">话题广场</h2>
          <p className="text-sm text-foreground-400 max-w-xl mx-auto">
            探索当前最受关注的影视话题标签，发现更多西瓜视频免费与91在线视频精彩内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topicTags.map((tag) => (
            <div
              key={tag.label}
              className="group flex items-center gap-3 px-5 py-3 bg-background-200/60 rounded-full hover:bg-primary-500/15 hover:border-primary-500/30 border border-transparent transition-all cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-200 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                #{tag.label}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{tag.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}